"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndirectGroupedTypeQueryForDatabase = exports.getIndirectGroupedTypeQuery = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const BranchingQueryDefinition_1 = require("../util/dynamodb/GraphQuery/BranchingQueryDefinition");
const groupHierarchyv2_1 = require("./groupHierarchyv2");
const EdgeTypeMatrix_1 = require("../classDependentTypes/EdgeTypes/EdgeTypeMatrix");
const edgeTypeMatrixFns_1 = require("../classDependentTypes/EdgeTypes/edgeTypeMatrixFns");
const debug = process.env.REACT_APP_DEBUG && false;
const GROUPER_TYPE = 'Group';
const USER_TYPE = 'User';
/** returns a function bound to  querySubjects which will return allowed groups as an array of ValidBusinessObjects  from a nodeEdgeMapper */
const getIndirectGroupedTypeQuery = ({ querySubjects, querySubjectType, allowedGroupSupportedType, }) => {
    const filteredQuerySubjects = querySubjects.filter((item) => item.type === querySubjectType);
    const SubjectTypeToSubjectTypeGroupType = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: 'SubjectTypeToSubjectTypeGroupType',
        path: [
            {
                adjacencyType: iotv_v3_types_1.AdjacentType.PARENT,
                objectTypeId: GROUPER_TYPE,
                edgeTypeId: (0, edgeTypeMatrixFns_1.getParentEdgeTypeId)(querySubjectType, GROUPER_TYPE),
                nodeFilters: [
                    { setOperation: iotv_v3_types_1.LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: iotv_v3_types_1.ComparisonType.EQUALS, value: querySubjectType }] },
                ],
            },
        ],
        subQueries: [],
    });
    const SubjectTypeToAllSubjectTypeGroups = (0, groupHierarchyv2_1.getNestedStructureBranchingQuery)({
        groupObjectType: GROUPER_TYPE,
        containedObjectType: querySubjectType,
        traversal: iotv_v3_types_1.Traversal.ASCENDING,
        includeSupportedTypeInstances: false,
    });
    const OtherGroupDescendingHierarchy = (0, groupHierarchyv2_1.getNestedStructureBranchingQuery)({
        groupObjectType: GROUPER_TYPE,
        containedObjectType: allowedGroupSupportedType,
        traversal: iotv_v3_types_1.Traversal.DESCENDING,
        includeSupportedTypeInstances: false,
    });
    const allowsEdgeDirection = querySubjectType === USER_TYPE ? iotv_v3_types_1.AdjacentType.CHILD : iotv_v3_types_1.AdjacentType.PARENT;
    const SubjectTypeGroupsToOtherGroupType = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: 'SubjectTypeGroupsAllowsOtherGroupType',
        path: [
            {
                adjacencyType: allowsEdgeDirection,
                objectTypeId: GROUPER_TYPE,
                edgeTypeId: EdgeTypeMatrix_1.edgeTypeMatrix.Group.Group.group_allows_group.edgeTypeId,
                nodeFilters: [
                    { setOperation: iotv_v3_types_1.LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: iotv_v3_types_1.ComparisonType.EQUALS, value: allowedGroupSupportedType }] },
                ],
            },
        ],
        subQueries: [],
    });
    const query = (applicationData) => {
        if (!OtherGroupDescendingHierarchy) {
            console.log(`WARN: OtherGroupDescendingHierarchy is not defined `);
        }
        const SubjectTypeGroupsRes = applicationData?.applyBranchingQuery(filteredQuerySubjects, SubjectTypeToSubjectTypeGroupType);
        const SubjectTypeGroups = SubjectTypeGroupsRes.getNodesOfType(GROUPER_TYPE);
        const ascendantGroupsRes = applicationData?.applyBranchingQuery(SubjectTypeGroups, SubjectTypeToAllSubjectTypeGroups);
        const ascendantGroups = ascendantGroupsRes.getNodesOfType(GROUPER_TYPE);
        const allowedGroupsRes = applicationData?.applyBranchingQuery(ascendantGroups, SubjectTypeGroupsToOtherGroupType);
        const allowedGroups = allowedGroupsRes.getNodesOfType(GROUPER_TYPE).filter((n) => n.supportedType === allowedGroupSupportedType);
        const descendingGroupsRes = applicationData?.applyBranchingQuery(allowedGroups, OtherGroupDescendingHierarchy);
        const descendingGroups = descendingGroupsRes.getNodesOfType(GROUPER_TYPE).filter((n) => n.supportedType === allowedGroupSupportedType);
        debug &&
            console.log({
                querySubjects,
                applicationData,
                SubjectTypeToSubjectTypeGroupType,
                allowedGroupSupportedType,
                SubjectTypeGroups,
                ascendantGroups,
                allowedGroups,
                descendingGroups,
            });
        return descendingGroups;
    };
    return query;
};
exports.getIndirectGroupedTypeQuery = getIndirectGroupedTypeQuery;
/** async derivation of getIndirectGroupedTypeQuery which can be run agains database, returns a function bound to  querySubjects which will return allowed groups as an array of ValidBusinessObjects  from database */
const getIndirectGroupedTypeQueryForDatabase = ({ querySubjects, querySubjectType, allowedGroupSupportedType, }) => {
    const filteredQuerySubjects = querySubjects.filter((item) => item.type === querySubjectType);
    const SubjectTypeToSubjectTypeGroupType = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: 'SubjectTypeToSubjectTypeGroupType',
        path: [
            {
                adjacencyType: iotv_v3_types_1.AdjacentType.PARENT,
                objectTypeId: GROUPER_TYPE,
                edgeTypeId: (0, edgeTypeMatrixFns_1.getParentEdgeTypeId)(querySubjectType, GROUPER_TYPE),
                nodeFilters: [
                    { setOperation: iotv_v3_types_1.LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: iotv_v3_types_1.ComparisonType.EQUALS, value: querySubjectType }] },
                ],
            },
        ],
        subQueries: [],
    });
    const SubjectTypeToAllSubjectTypeGroups = (0, groupHierarchyv2_1.getNestedStructureBranchingQuery)({
        groupObjectType: GROUPER_TYPE,
        containedObjectType: querySubjectType,
        traversal: iotv_v3_types_1.Traversal.ASCENDING,
        includeSupportedTypeInstances: false,
    });
    const OtherGroupDescendingHierarchy = (0, groupHierarchyv2_1.getNestedStructureBranchingQuery)({
        groupObjectType: GROUPER_TYPE,
        containedObjectType: allowedGroupSupportedType,
        traversal: iotv_v3_types_1.Traversal.DESCENDING,
        includeSupportedTypeInstances: false,
    });
    const allowsEdgeDirection = querySubjectType === USER_TYPE ? iotv_v3_types_1.AdjacentType.CHILD : iotv_v3_types_1.AdjacentType.PARENT;
    const SubjectTypeGroupsToOtherGroupType = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: 'SubjectTypeGroupsAllowsOtherGroupType',
        path: [
            {
                adjacencyType: allowsEdgeDirection,
                objectTypeId: GROUPER_TYPE,
                edgeTypeId: EdgeTypeMatrix_1.edgeTypeMatrix.Group.Group.group_allows_group.edgeTypeId,
                nodeFilters: [
                    { setOperation: iotv_v3_types_1.LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: iotv_v3_types_1.ComparisonType.EQUALS, value: allowedGroupSupportedType }] },
                ],
            },
        ],
        subQueries: [],
    });
    const query = async (branchingQueryRunner) => {
        let res = { err: null, data: null };
        const SubjectTypeGroupsRes = await branchingQueryRunner({ topLevelQuery: SubjectTypeToSubjectTypeGroupType, contextObjects: filteredQuerySubjects });
        if (SubjectTypeGroupsRes.err) {
            res.err = SubjectTypeGroupsRes.err;
        }
        else {
            const SubjectTypeGroups = SubjectTypeGroupsRes.data?.getNodesOfType(GROUPER_TYPE) ?? [];
            if (SubjectTypeGroups?.length > 0) {
                const ascendantGroupsRes = await branchingQueryRunner({ contextObjects: SubjectTypeGroups, topLevelQuery: SubjectTypeToAllSubjectTypeGroups });
                if (ascendantGroupsRes.err) {
                    res.err = ascendantGroupsRes.err;
                }
                else {
                    const ascendantGroups = ascendantGroupsRes.data?.getNodesOfType(GROUPER_TYPE) ?? [];
                    if (ascendantGroups.length > 0) {
                        const allowedGroupsRes = await branchingQueryRunner({ contextObjects: ascendantGroups, topLevelQuery: SubjectTypeGroupsToOtherGroupType });
                        if (allowedGroupsRes.err) {
                            res.err = allowedGroupsRes.err;
                        }
                        else {
                            const allowedGroups = (allowedGroupsRes.data?.getNodesOfType(GROUPER_TYPE) ?? []).filter((n) => n.supportedType === allowedGroupSupportedType);
                            if (allowedGroups.length > 0) {
                                const descendingGroupsRes = await branchingQueryRunner({ contextObjects: allowedGroups, topLevelQuery: OtherGroupDescendingHierarchy });
                                if (descendingGroupsRes.err) {
                                    res.err = descendingGroupsRes.err;
                                }
                                else {
                                    const descendingGroupsRes = await branchingQueryRunner({ contextObjects: allowedGroups, topLevelQuery: OtherGroupDescendingHierarchy });
                                    const descendingGroups = (descendingGroupsRes.data?.getNodesOfType(GROUPER_TYPE) ?? []).filter((n) => n.supportedType === allowedGroupSupportedType);
                                    res.data = descendingGroups;
                                    debug &&
                                        console.log({
                                            querySubjects,
                                            SubjectTypeToSubjectTypeGroupType,
                                            allowedGroupSupportedType,
                                            SubjectTypeGroups,
                                            ascendantGroups,
                                            allowedGroups,
                                            descendingGroups,
                                        });
                                }
                            }
                        }
                    }
                }
            }
        }
        return res;
    };
    return query;
};
exports.getIndirectGroupedTypeQueryForDatabase = getIndirectGroupedTypeQueryForDatabase;
